module.exports = __webpack_public_path__ + "static/img/icon_help.9b503c70.png";